import { APIErrorResponse, ICompanyDetails } from "src/types/generic";
import apiClient from "../apiClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import { IZatcaResponse } from "src/types/integrations/zatca";

export const useGetZatcaStatus = () =>
  useQuery<any, APIErrorResponse, { data: IZatcaResponse }>({
    queryKey: ["get-zatca-status"],
    queryFn: async () => {
      return apiClient.get(`/api/fai/status`);
    },
  });

interface ICompanyDetailsWithZatcaKeys extends ICompanyDetails {
  force: boolean;
  zatca_otp: string;
}

export const useConnectZatca = () =>
  useMutation<any, APIErrorResponse, ICompanyDetailsWithZatcaKeys>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/fai/connect`, data);
    },
  });

export const useDisConnectZatca = () =>
  useMutation<any, APIErrorResponse, void>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/fai/disconnect`, data);
    },
  });
